import { render, staticRenderFns } from "./TrainingNav.vue?vue&type=template&id=a3fe863c&scoped=true&lang=pug"
import script from "./TrainingNav.vue?vue&type=script&lang=ts"
export * from "./TrainingNav.vue?vue&type=script&lang=ts"
import style0 from "./TrainingNav.vue?vue&type=style&index=0&id=a3fe863c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fe863c",
  null
  
)

export default component.exports